



































































/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue';
import { BUTTON } from '@/constants/label';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import { Color, OutStatus, JuchuStatus, TorikeshiFlg } from '@/constants/constants';
import { dateStrToNum } from '@/utils/utils';
import CtrlMessageDialog from '../common/control/CtrlMessageDialog.vue';

export default Vue.extend<any, any, any, any>({
  name: 'G_030_JuchuToiawase_Rireki_Table',
  components: {
    CtrlNormalBtn,
    CtrlMessageDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    childItem: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    BUTTON,
    Color,
    JuchuStatus,
    TorikeshiFlg,
    items: [],
    headers: [
      {
        text: '履歴№',
        value: 'rirekiNo',
        sortable: false,
        width: 70,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: '変更日',
        value: 'henkoYmd',
        sortable: false,
        width: 100,
        class: 'text-center',
        cellClass: 'text-center',
      },
      {
        text: '納品希望日',
        value: 'nohinKiboYmd',
        sortable: false,
        width: 100,
        class: 'text-center',
        cellClass: 'text-center',
      },
      {
        text: '納品予定日',
        value: 'nohinYoteiYmd',
        sortable: false,
        width: 100,
        class: 'text-center',
        cellClass: 'text-center',
      },
      {
        text: '変更内容',
        value: 'henkoNaiyo',
        class: 'text-start',
        cellClass: 'text-start',
        sortable: false,
        width: 400,
      },
      { text: '', value: 'action', sortable: false, width: 50 },
    ],
    footerProps: {},
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    messageShow: false,
    messageId: '',
    messageTextParam: [],
  }),
  computed: {
    tableHeight() {
      return this.$vuetify.breakpoint.height - 400;
    },
  },
  methods: {
    callParentInfo(item: any) {
      this.childItem.rirekiNo = item.rirekiNo;
      this.$emit('info', this.childItem);
    },
    hide() {
      this.$emit('hide');
    },
    handleOkMessage() {
      this.messageShow = false;
      this.messageId = '';
      this.messageTextParam = [];
      this.hide();
    },
    async getRirekiList() {
      this.$store.dispatch('common/setIsLoading', true);

      const params = {
        juchuEntryJigyoshoCd: this.childItem.juchuEntryJigyoshoCd,
        juchuEntryYmd: dateStrToNum(this.childItem.juchuEntryYmd),
        juchuNo: this.childItem.juchuNo,
      };

      const res = await this.$store.dispatch('g030/getRirekiList', params);
      this.$store.dispatch('common/setIsLoading', false);

      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.messageID &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        this.messageId = res.data.error.messageID;
        this.messageTextParam = res.data.error.messageArgs;
        this.messageShow = true;
        return;
      }

      this.items = res.data.responseData ? res.data.responseData : [];
    },
  },
  created() {
    this.getRirekiList();
  },
});
